<template>
  <div>
    <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
      <div id="myCal">
        <!-- 保费试算 -->
        <div class="title_">
          <div class="cutleft_">保费试算</div>
          <div class="cutoff_"></div>
        </div>
        <a-row class="changeStyle_">
          <a-col :span="18">
            <div class="form_item flex_start">
              <label>保障期间</label>
              <div class="right_">
                <a-radio-group :disabled="disabledAll" name="guapre" @change="e => changeData(e.target.value, 'BZQJa')" v-model="guapre">
                  <a-radio v-for="item in guarantPre" :key="item.key" :value="item.key">{{ item.value }}</a-radio>
                </a-radio-group>
              </div>
            </div>
            <div>
              <a @click="$tools.downloadFile(fileCodeContent.occ_url)">职业类别表</a>
            </div>
            <div class="form_item" style="justify-content: start">
              <label>投保职业</label>
              <div class="right_">
                <div class="check_item s_input" v-for="(item, index) in occupationNumberList" :key="index + 'occ'" :class="{ on: item.check == true }">
                  <label for> {{ item.occupationKind }}类 </label>
                  <a-input :disabled="disabledAll" @blur="e => changeData(e.target.value)" v-model="item.personNum"></a-input>
                  <span>人</span>
                </div>

                <div class="check_item">
                  <span>总人数：{{ totalNumber }}人</span>
                </div>
              </div>
            </div>
            <div v-if="isNewProduct" class="form_items">
              <label>是否涉高&nbsp;&nbsp;&nbsp;</label>
              <div class="right_">
                <div class="check_item">
                  <a-radio-group name="radioGroup" :default-value="2" :disabled="disabledAll" v-model="countData.SFSGa" @change="e => changeData(e.target.value, 'SFSGa')">
                    <a-radio :value="2">不涉高</a-radio>
                    <a-radio :value="1">涉高</a-radio>
                  </a-radio-group>
                </div>
              </div>
            </div>
            <div class="form_item">
              <a-form-item :label-col="{ span: 9 }" label="投保人名称">
                <a-input
                  style="width: 280px"
                  v-model="countData.name"
                  @change="e => changeData(e.target.value, 'name')"
                  placeholder="请填写投保人名称"
                  :disabled="disabledAll"
                  v-decorator="[
                    'countData.name',
                    {
                      rules: [{ required: true, message: '请输入投保人名称' }]
                    }
                  ]"
                ></a-input>
              </a-form-item>
              <p v-if="!isNewProduct" style="margin-left: 120px; color: red">
                ①不承保天津地址所有企业。
              </p>
            </div>
          </a-col>
          <a-col :offset="2" :span="4" class="calRight_">
            <div class="calTxt_">保费合计</div>
            <div class="calmoney_">¥ {{ premiumSum }}</div>
          </a-col>
        </a-row>
      </div>
      <div class="risk_">
        <div v-if="!isNewProduct">
          <p class="p-header">必选方案</p>
          <div class="form_item">
            <label>方案选择</label>
            <div class="right_" style="width: 300px">
              <a-select :disabled="true" placeholder="请选择" class="select_" @change="value => changePlanData(value)" v-model="countData.planSelect">
                <a-select-option v-for="item in planOptions" :key="item.value" :value="item.value">{{ item.name }}</a-select-option>
              </a-select>
            </div>
          </div>
        </div>
        <p class="p-header">主险</p>
        <!-- 意外伤害身故、残疾 -->
        <div class="form_item">
          <label>意外身故/伤残保险金</label>
          <div class="right_">
            <a-select placeholder="请选择" style="width: 300px" class="select_" :disabled="disabledAll" @change="value => changeData(value, 'SWCJ')" v-model="countData.SWCJ">
              <a-select-option v-for="item in SWCJOptions" :key="item.value + 'SWCJ'" :value="item.value"> {{ item.name }}</a-select-option>
            </a-select>
          </div>
        </div>
        <p class="p-header">附加险</p>
        <div class="flex_">
          <!-- 意外伤害医疗费用 -->
          <div class="form_item">
            <label>意外伤害医疗保险金</label>
            <div class="right_">
              <a-select :disabled="disabledAll" placeholder="请选择" style="width: 300px" class="select_" v-model="countData.YLFY" @change="value => changeData(value, 'YLFY')">
                <a-select-option v-for="(item, index) in YLFYOptions" :key="item.value + 'YLFY' + index" :value="item.value" :disabled="item.disabled">{{ item.name }}</a-select-option>
              </a-select>
            </div>
          </div>
          <!-- 意外住院津贴责任 -->
          <div class="form_item">
            <label>意外伤害住院津贴保险金</label>
            <div class="right_">
              <a-select placeholder="请选择" style="width: 300px" :disabled="disabledAll" class="select_" v-model="countData.ZYJT" @change="value => changeData(value, 'ZYJT')">
                <a-select-option v-for="item in ZYJTOptions" :key="item.value + 'ZYJT'" :value="item.value"> {{ item.name }}</a-select-option>
              </a-select>
            </div>
          </div>
        </div>
        <div class="btn_list">
          <a-button style="margin-bottom:50px;" class="calBtn_" type="primary" @click="goplicy" :disabled="disabledAll"> 完成报价，立即投保</a-button>
          <a-button class="calBtn_" type="primary" @click="countPremiumSum" :disabled="disabledAll">刷新试算</a-button>
        </div>
      </div>
    </a-form>
  </div>
</template>

<script>
import utils from './../js/utils';
import { riskinfoMixin } from '@/mixins/riskinfoMixin.js';
export default {
  mixins: [riskinfoMixin],
  props: ['isNewProduct'],
  data() {
    return {
      productCode: '',
      plan: '',
      form: this.$form.createForm(this, { name: 'advanced_search' }),
      guapre: 12,
      //保障期间
      guarantPre: utils.guarantPre,
      premiumSum: 0, //总保费
      // 扩展残疾鉴定国家工伤标准
      KZSCOptions: utils.KZSCOptions,
      // 测算要提交的数据
      countData: {
        planSelect: 'GFTYX20Hone', //方案选择
        BZQJa: 12, //保障期间?
        name: '', //投保人名称
        SWCJ: 100000, //意外伤害身故、残疾
        YLFY: 0, //意外医疗费用
        ZYJT: 0, //意外住院津贴
        SFSGa: 2 // 是否涉高
      },
      //提交data
      data: {
        riskInfos: [],
        salPolicy: {
          productCode: '', //产品code
          optionalFlag: 12, //保费期限
          planCode: ''
        },
        salPolicyHolder: {
          addfifty: '1', // 测算类型
          stature: 0 //是否高空（0-否，1-是）
        },
        salPolicyExt: {
          isworkheightinvolved: '2'
        },
        premiumBaseDtoList: [] //人数
      },
      planType: 'A',
      occupationNumberList: utils.occupationNumberList,
      planOptions: utils.planOptions
    };
  },
  computed: {
    // 意外伤害身故、残疾
    SWCJOptions() {
      let Options = utils.SWCJOptions;
      return Options;
    },
    // 扩展社保范围外医疗费用（含甲乙丙类自付和自费）
    ZFYFOptions() {
      let Options = [
        //自费药费用(即保司系统自费药)选择框
        {
          value: 0,
          name: '不附加'
        },
        {
          value: 0.1,
          name: '意外医疗费用保额的10%'
        },
        {
          value: 0.2,
          name: '意外医疗费用保额的20%'
        }
      ];
      return Options;
    },
    // 意外伤害医疗费用
    YLFYOptions() {
      let option = utils.YLFYOptions;
      let SWCJ = this.countData.SWCJ; // 主险保额
      return option.filter(item => item.value <= SWCJ * 0.2);
    },
    // 意外住院津贴
    ZYJTOptions() {
      let ZYJTOptions = [
        //意外住院津贴责任 : ZYJT
        {
          value: 0,
          name: '不附加'
        },
        {
          value: 50,
          name: '50元/天'
        },
        {
          value: 100,
          name: '100元/天'
        }
      ];
      return ZYJTOptions;
    },
    // 选的总投保人数
    totalNumber() {
      let num = 0;
      this.occupationNumberList.forEach(e => {
        num += Number(e.personNum);
      });
      return parseInt(num);
    },
    // 险种的数组
    riskInfos() {
      let infos = [
        {
          riskCode: '2114104', //意外伤害身故、残疾
          dutyCode: '410406',
          dutyMult: this.countData.SWCJ / 100000,
          amount: this.countData.SWCJ,
          premiumAmt: 0,
          riskName: `意外伤害身故、残疾`,
          riskAmountDesc: this.countData.SWCJ
        },
        {
          riskCode: '2114104', //意外医疗费用补偿
          dutyCode: '410407',
          dutyMult: this.countData.YLFY / 10000,
          amount: this.countData.YLFY,
          riskName: `意外伤害医疗费用`,
          premiumAmt: 0,
          riskAmountDesc: this.countData.YLFY
        },
        {
          riskCode: '2114104', //意外伤害住院津贴
          dutyCode: '410408',
          dutyMult: this.countData.ZYJT / 10,
          amount: this.countData.ZYJT,
          premiumAmt: 0,
          riskName: `意外伤害住院津贴`,
          riskAmountDesc: `${this.countData.ZYJT}元/天`
        }
      ];
      return infos;
    }
  },
  watch: {
    'countData.name'(val) {
      if (!this.isNewProduct && val.indexOf('天津') != -1) {
        this.countData.name = '';
        this.form.setFieldsValue({
          countData: {
            name: ''
          }
        });
        this.$message.warning('天津地区企业不可投保');
      }
    }
  },
  created() {
    const { planCode } = this.$route.query;
    this.changePlanData(planCode);
  },
  mounted() {
    
    this.$bus.$on('busRiskInfos', data => {
      //险种信息 附指   保单详情中的险种信息
      let obj = this.$lodash.cloneDeep(this.countData);
      data.forEach(e => {
        if (e.riskCode == '2114104' && e.dutyCode == '410406') obj.SWCJ = e.riskAmountDesc - 0;
        if (e.riskCode == '2114104' && e.dutyCode == '410407') obj.YLFY = e.riskAmountDesc - 0;
        if (e.riskCode == '2114104' && e.dutyCode == '410408') obj.ZYJT = e.dutyMult * 10;
      });
      this.countData = { ...obj };
      
    });
  },
  beforeDestroy() {
    this.$bus.$off('busRiskInfos');
  },
  methods: {
    // 去投保
    goplicy() {
      this.$store.commit('setAgreement', true);
    },
    //选择计划
    changePlanData(value) {
      this.plan = value;
      this.countData.planSelect = value;
      let options = this.planOptions.filter(item => item.value == value)[0];
      this.countData = { ...this.countData, ...options };
      this.$router.push({
        path: location.pathname,
        query: {
          u: this.$route.query.u,
          p: this.$route.query.p,
          sign: this.$route.query.sign,
          policyId: this.$route.query.policyId,
          planCode: value
        }
      });
      this.changeData('planSelect', value);
    },
    // 改变试算的数据
    changeData(value, param) {
      if (!this.isNewProduct && param == 'name') {
        if (!this.isNewProduct && value.indexOf('天津') != -1) {
          return;
        }
      }
      let premiumBaseDtoList = this.occupationNumberList.filter(item => item.personNum > 0);
      let riskInfos = this.riskInfos.filter(item => item.amount > 0);
      this.countData[param] = value;
      
      this.data = {
        riskInfos: riskInfos, //险种信息
        salPolicy: {
          productCode: this.productCode, //产品code
          optionalFlag: this.countData.BZQJa.toString(), //保费期限
          planCode: this.plan || this.productCode
        },
        salPolicyHolder: {
          addfifty: '1', // 测算类型
          name: this.countData.name
        },
        salPolicyExt: {
          isworkheightinvolved: this.countData.SFSGa // 是否涉高
        },
        premiumBaseDtoList: premiumBaseDtoList //人数
      };
      let arrData = JSON.parse(JSON.stringify(this.data));
      this.$bus.$emit('onRiskInfos', arrData, param);
      if (premiumBaseDtoList.length == 0) {
        return;
      }
      // 如果不是 国富人寿1-6类团意险（2023版互联网）
      if (!this.isNewProduct) {
        delete arrData['premiumBaseDtoList']; //投保职业人数是不参与下面的计算的
        delete arrData['salPolicyExt']; //是否涉高是不参与下面的计算的
      }
      this.countPremiumSum();
    },
    //保费试算
    countPremiumSum() {
      this.data.salPolicyHolder.addfifty = '1';
      this.form.validateFields(err => {
        if (!err) {
          
          if (!this.totalNumber) {
            this.premiumSum = 0;
            this.$message.warning('请选择投保人数');
            return;
          }
          this.$api.calPremiumEmployer(this.data).then(res => {
            if (res.data.success) {
              let data = res.data.content;
              this.premiumSum = data.totalPremium;
            } else {
              this.$message.error(res.data.returnMsg + '错误');
            }
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.calTxt_ {
  font-size: 18px !important;
  font-weight: bold !important;
  color: #666666;
}

.pre-box {
  margin-top: 15px;
}

.form_items {
  display: flex;
  width: 100%;
  color: #333;
  margin-bottom: 10px;
}

.risk_ {
  width: 60%;
}

.btn_list {
  margin-top: 20px;
  display: flex;

  .calBtn_ {
    margin-right: 30px;
  }
}

.flex_ {
  display: flex;
  flex-wrap: wrap;
}

.form_item {
  display: flex;
  justify-content: space-between;
  width: 100%;
  color: #333;
  margin-bottom: 10px;

  &.width_50 {
    width: 50%;
  }

  &.width_40 {
    width: 40%;
  }

  &.width_60 {
    width: 60%;
  }

  > label {
    white-space: nowrap;
    margin-right: 10px;
    margin-top: 15px;
  }

  .right_ {
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;

    .select_ {
      margin-top: 10px;
    }

    .check_item {
      display: flex;
      align-items: center;
      margin-right: 10px;
      margin-top: 10px;

      &.on {
        label {
          border-color: #fe8f2d;
        }
      }

      label {
        // border: 1px solid #d9d9d9;
        padding: 3px 10px;
        border-radius: 3px;
        margin-right: 5px;
      }

      &.s_input input {
        width: 50px;
      }

      input {
        width: 150px;
        margin-right: 5px;
      }
    }
  }
}

.p-header {
  width: 100%;
  font-weight: bold;
  font-size: 15px;
  margin-bottom: 0;
}
</style>
